export default __webpack_public_path__ + "static/imgEleven-d23c0532ac1a999dc8569993fe17bf5e.jpg";